import React, { Component } from 'react';
import { renderIntoContainer } from 'react/root/containerRoot';

import { Dashboard } from '../components/Dashboard';

import LazyLoader from "../imports/LazyLoader.js";
import LadderSuspense from "../react/elements/LadderSuspense.jsx";

$(async function() {
	await Dashboard.startupEvents;

	const dailyMatchesContainer = document.getElementById('daily_matches_react');
	if(dailyMatchesContainer) {
		LazyLoader.dailyMatches()
			.then(({ default: DailyMatches }) => {
				renderIntoContainer(
					<LadderSuspense>
						<DailyMatches />
					</LadderSuspense>,
					dailyMatchesContainer
				);
			});
		return;
	}

	const matchMapContainer = document.getElementById('match_map');
	if(matchMapContainer) {
		LazyLoader.matchMap()
			.then(({ default: MatchMap }) => {
				renderIntoContainer(
					<LadderSuspense>
						<MatchMap />
					</LadderSuspense>,
					matchMapContainer
				);
			});
		return;
	}

	const rankedSeasonStatsContainer = document.getElementById('ranked_season_stats');
	if(rankedSeasonStatsContainer) {
		LazyLoader.rankedSeasonStats()
			.then(({ default: RankedSeasonStats }) => {
				renderIntoContainer(
					<RankedSeasonStats
					/>, rankedSeasonStatsContainer
				);
			});
		return;
	}
});



